<template>
  <q-layout view="lHh Lpr lFf" class="bg-blue-grey-2 my-font">
    <!-- header -->
    <q-header v-if="route.name != 'Login'" class="mobile-container q-mx-auto">
      <q-card-section
        v-if="
          route.name == 'home' ||
          route.name == 'FormTask' ||
          route.name == 'FormLeave'
        "
        class="head-bg text-white row items-center justify-between"
        style="height: 160px"
      >
        <div>
          <div>Semangat untuk hari ini,</div>
          <div v-if="route.meta.user" class="text-bold l-text-title">
            {{ route.meta.user.name }}
          </div>
        </div>
        <div
          class="row items-center justify-center icon-bg cursor-pointer"
          @click="router.push('/profile')"
        >
          <div
            class="l-text-title text-blue-14 text-bold"
            v-if="route.meta.user"
          >
            {{ route.meta.user.name[0].toUpperCase() }}
          </div>
        </div>
      </q-card-section>
    </q-header>
    <q-page-container class="mobile-container q-mx-auto">
      <router-view />

      <!-- control -->
      <q-card-section
        v-if="
          route.name != 'Login' &&
          route.name != 'profile' &&
          route.name != 'ChangeProfile' &&
          route.name != 'ChangePassword' &&
          route.name != 'FormTask' &&
          route.name != 'FormLeave' &&
          route.meta.user?.role != 'manager'
        "
        class="q-pa-none bg-transparant"
      >
        <div class="l-grow column items-center" style="margin-bottom: -35px">
          <q-fab color="secondary" icon="add" padding="lg" direction="up">
            <q-fab-action
              color="primary"
              @click="router.push('/form-task')"
              icon="assignment"
            />
            <q-fab-action
              color="primary"
              @click="router.push('/form-leave')"
              icon="work_off"
            />
          </q-fab>
        </div>
        <q-separator />
        <div
          class="row justify-between q-py-md q-px-xl bg-white"
          style="height: 110px"
        >
          <div
            class="column q-gutter-y-sm items-center cursor-pointer"
            @click="
              data.tab = 'visit';
              router.push('/');
            "
            :style="data.tab == 'visit' ? 'color: #2962ff' : 'color: #BDBDBD'"
          >
            <q-icon name="assignment" size="lg" />
            <div>Tugas Hari Ini</div>
          </div>
          <div
            class="column q-gutter-y-sm items-center cursor-pointer"
            @click="
              data.tab = 'activity';
              router.push(`/detail/${route.meta.user?.id}`);
            "
            :style="
              data.tab == 'activity' ? 'color: #2962ff' : 'color: #BDBDBD'
            "
          >
            <q-icon name="analytics" size="lg" />
            <div>Log Aktivitas</div>
          </div>
        </div>
      </q-card-section>
    </q-page-container>
  </q-layout>
</template>

<script>
import useBasic from "@/composables/useBasic";

export default {
  name: "LayoutDefault",

  setup() {
    const {
      ref,
      reactive,
      router,
      route,
      watch,
      onMounted,
      $q,
      computed,
      waitThis,
      loadThis,
    } = useBasic();

    let data = reactive({
      tab: "visit",
    });

    watch(
      () => route.name,
      (newRouteName) => {
        if (newRouteName === "home") {
          data.tab = "visit";
        }
        if (newRouteName === "ActivityLog") {
          data.tab = "activity";
        }
      }
    );
    return {
      route,
      router,
      data,
      loadThis,
      onClick() {
        // console.log('Clicked on a fab action')
      },
    };
  },
};
</script>

<style lang="scss">
@import "@/styles/quasar.scss";
.head-bg {
  background: linear-gradient(90deg, #2962ff 0%, #448aff 100%);
}
.icon-bg {
  border-radius: 50%;
  background-color: #cddaff;
  width: 66px;
  height: 66px;
  @media only screen and (max-width: 500px) {
    width: 50px;
    height: 50px;
  }
}

.mobile-container {
  max-width: 450px;
  min-width: 325px;
  flex-grow: 99;
}

.l-grow {
  flex-grow: 99;
}
.bg-brand {
  background: #0f75bc !important;
}

.text-brand {
  color: #0f75bc !important;
}

@font-face {
  font-family: customfont;
  src: url(./styles/fonts/Poppins-Regular.ttf);
}

@font-face {
  font-family: customfont;
  src: url("./styles/fonts/Poppins-Bold.ttf");
  font-weight: 700;
}

@font-face {
  font-family: customfont;
  src: url("./styles/fonts/Poppins-SemiBold.ttf");
  font-weight: 500;
}

@font-face {
  font-family: customfont;
  src: url("./styles/fonts/Poppins-Light.ttf");
  font-weight: 300;
}

@font-face {
  font-family: customfont;
  src: url("./styles/fonts/Poppins-Thin.ttf");
  font-weight: 200;
}

.my-font {
  font-family: "customfont";
}

.l-text-header {
  font-size: 40px !important;
  // line-height: 1.8;
  @media only screen and (max-width: 900px) {
    font-size: 36px !important;
  }
  @media only screen and (max-width: 500px) {
    font-size: 24px !important;
  }
}

.l-text-title {
  font-size: 32px !important;
  // line-height: 1.8;
  @media only screen and (max-width: 900px) {
    font-size: 26px !important;
  }
  @media only screen and (max-width: 500px) {
    font-size: 20px !important;
  }
}

.l-text-subtitle {
  font-size: 20px !important;
  // line-height: 1.8;
  @media only screen and (max-width: 500px) {
    font-size: 16px !important;
  }
}

.l-text-detail {
  font-size: 18px !important;
  // line-height: 1.8;
  @media only screen and (max-width: 500px) {
    font-size: 13px !important;
  }
}

.l-text-description {
  font-size: 14px !important;
  // line-height: 1.8;
  @media only screen and (max-width: 500px) {
    font-size: 12px !important;
  }
}

.border-card {
  border-radius: 10px !important;
}

.long-text-dots {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.kiri-radius {
  border: 1px solid #bbbbbb;
  border-radius: 8px 0 0 8px !important;
}

.kanan-radius {
  border: 1px solid #bbbbbb;
  border-radius: 0 8px 8px 0 !important;
}
.atas-radius {
  border: 1px solid #bbbbbb;
  border-radius: 8px 8px 0 0 !important;
}
.bawah-radius {
  border: 1px solid #bbbbbb;
  border-radius: 0 0 8px 8px !important;
}

.all-radius {
  border: 1px solid #bbbbbb;
  border-radius: 8px 8px 8px 8px !important;
}

.border_cari {
  border-left: 5px solid #0f75bc;
}
.border_prospek {
  border-left: 5px solid #fca825;
}
.border_follow {
  border-left: 5px solid #46cdf0;
}
.border_new_prod {
  border-left: 5px solid #379d1d;
}
.border_complain {
  border-left: 5px solid #fc4827;
}
</style>
